import { useAppSelector } from "src/store";
import { helper } from "./helper";
import VwKullaniciRolyetkiDTO from "src/models/RolYetki/VwKullaniciRolyetkiDTO";

/**
 * Aktif URL'ye göre menu ve yetkiyi bulma fonksiyonu
*/
export const useFindAuthByUrl = (): VwKullaniciRolyetkiDTO => {
    let result: VwKullaniciRolyetkiDTO = new VwKullaniciRolyetkiDTO();
    const menuYetkiListesi = useAppSelector(s => s.menuAuth.data);
    // Tarayıcıda girili mevcut URL bilgisini alıyoruz
    const mevcutUrl = window.location.pathname;
    // URL'yi parçalara ayırıyoruz
    const urlParcalari = mevcutUrl?.split('/').filter(Boolean);
    const urlAyar = (url: string) => url.startsWith('/') ? url : '/' + url;
    // URL'nin en uzun parçasından başlayarak menüde arama yapıyoruz
    for (let i = urlParcalari.length; i > 0; i--) {
        // URL'nin ilk i parçasını birleştirerek yeni bir parça oluşturuyoruz (örn: /modul/sayfa/detay)
        const parcaliUrl = '/' + urlParcalari.slice(0, i).join('/');
        result = menuYetkiListesi.find((item) => helper.UpperCaseAsc(urlAyar(parcaliUrl)) === helper.UpperCaseAsc(urlAyar(item.link)));
        // Eğer eşleşen bir menü bulunduysa, döngüyü sonlandırıyoruz
        if (result) break;
    }
    return result;
};